import { useStores } from '../../../app/root/domain/stores/useStores';

export const useLocationStore = () => {
	const { locationStore } = useStores();

	return locationStore;
};
